import {XauditModel} from '../xaudit.model';

export class CfgTaskConfigurationModel extends XauditModel {
  TaskCfgID: string;
  LOCID: number;
  enumUserTaskTypeID: string;
  enumTaskTimeCalculationID: string;
  DelayTimeInDays: number;
  LeadTimeInDays: number;
  isManual: boolean;
}

